import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Menu = styled.ul`
	list-style: none;
	padding: var(--padding-2);
	margin: 0;
	background-color: var(--modal-bg-3);
	box-shadow: var(--container-box-shadow);
	border-radius: var(--small-border-radius);
`;

export const MenuItem = styled.li`
	display: flex;
	align-items: center;
	gap: 1rem;
	cursor: pointer;
	background-color: var(--modal-bg-3);
	padding: var(--padding-2) var(--padding-3);
	border-radius: var(--small-border-radius);
	border-inline-start: 2px solid transparent;

	&.disabled {
		background-color: var(--input-disabled-bg-color);
		color: var(--black-40);
		-webkit-text-fill-color: var(--black-40);
		opacity: 1;
		cursor: not-allowed;

		> .typography {
			color: var(--black-40);
		}
	}

	:first-of-type {
		border-top-left-radius: var(--small-border-radius);
		border-top-right-radius: var(--small-border-radius);
	}

	:last-of-type {
		border-bottom-left-radius: var(--small-border-radius);
		border-bottom-right-radius: var(--small-border-radius);
	}

	&:hover:not(.disabled) {
		background-color: var(--table-selected-color);
	}

	> .typography,
	> .icon {
		color: var(--black);
		font-size: var(--paragraph3-font-size);
	}

	&.selected {
		background-color: var(--table-active-color);
		border-inline-start: 2px solid var(--blue);
		border-radius: 0;
	}
`;

export const MobileTitleContainer = styled.div`
	display: none;
	padding: 1rem 2rem;

	@media ${Breakpoints.mobile} {
		display: block;
	}
`;
